const host = "https://api-vote-production.up.railway.app/api/v1"

export const getParticipants = `${host}/participants`
export const postVotos = `${host}/voters`
export const VerifyUsers = `${host}/voters`
